import styled from 'styled-components'

const EqualTwoStyle = styled.div`
	--equalWidth: 50%;
	--equalDistance: var(--sp6x);
	--equalFileHeight: 67%;

	margin-top: var(--bannerDistance);

	.equalTwoWrap {
		display: flex;
		flex-wrap: wrap;
		margin-left: calc(-1 * calc(var(--equalDistance) / 2));
		margin-right: calc(-1 * calc(var(--equalDistance) / 2));

		.col-50 {
			width: var(--equalWidth);
			padding: 0 calc(var(--equalDistance) / 2);

			.imageCont,
			.videoCont {
				--proportion: var(--equalFileHeight);
				width: 100%;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeL}) {
		--equalDistance: var(--sp5x);
		--equalFileHeight: 67.3%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeM}) {
		--equalDistance: var(--sp4x);
		--equalFileHeight: 67.5%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeS}) {
		--equalDistance: var(--sp4x);
		--equalFileHeight: 67.8%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeXS}) {
		--equalDistance: var(--sp3x);
		--equalFileHeight: 67.3%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSize}) {
		--equalDistance: var(--sp3x);
		--equalFileHeight: 67.4%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSizeS}) {
		--equalDistance: var(--sp3x);
		--equalFileHeight: 67.4%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--equalWidth: 100%;
		--equalDistance: var(--sp4x);
		--equalFileHeight: 82%;

		.equalTwoWrap {
			.col-50 {
				&:nth-child(2) {
					margin-top: var(--equalDistance);
				}
			}
		}
	}
`

export default EqualTwoStyle
